import { Component, computed, input } from '@angular/core';
import { HighlightedMessagePart } from '../../models/highlighted-message.model';

@Component({
  selector: 'app-highlighted-message',
  imports: [],
  templateUrl: './highlighted-message.component.html',
  styleUrl: './highlighted-message.component.scss',
})
export class HighlightedMessageComponent {
  readonly text = input.required<string>();
  readonly highlights = input<string[]>([]);

  readonly parts = computed(() => this.buildParts(this.text(), this.highlights()));

  private buildParts(text: string, highlights: string[]): HighlightedMessagePart[] {
    let result: HighlightedMessagePart[] = [text];

    for (const highlight of highlights) {
      if (!highlight) {
        continue;
      }

      result = result.flatMap((part) => {
        if (typeof part !== 'string') {
          return [part];
        }

        return part
          .split(highlight)
          .flatMap((segment, index, arr) =>
            index < arr.length - 1 ? [segment, { highlight }] : [segment],
          );
      });
    }

    return result;
  }

  public isHighlightPart(part: HighlightedMessagePart): part is { highlight: string } {
    return typeof part !== 'string';
  }
}
